import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterMinorAccountIntro() {
    const appName = i18n.t('Global.appNames.libreView');
    return (React.createElement(ContentContainer, null,
        React.createElement(Stack, { flexDirection: "column", alignItems: "center", paddingHorizontal: "$4", marginTop: "$1" },
            React.createElement("img", { id: "CreateAccountIntro-image-of-family", src: i18n.t('CreateAccountIntro.content.createAccountIntro.media.introMinor'), alt: "a family with the father hugging the mom and the daughter in the middle of them", style: {
                    maxWidth: '100vw',
                    height: '260px',
                    objectFit: 'contain',
                    margin: '12px auto 20px auto',
                } }),
            React.createElement(Stack, { flexDirection: "column", gap: "$4" },
                React.createElement(Text, { type: "$bodyBase.medium", color: "$text.100", testID: "CreateAccountIntro.content.createAccountIntro.primaryText", nativeID: "CreateAccountIntro.content.createAccountIntro.primaryText" }, i18n.t('CreateAccountIntro.content.createAccountIntro.primaryText')),
                React.createElement(Text, { type: "$bodyBase.medium", color: "$text.100", testID: "CreateAccountIntro.content.createAccountIntro.bodyText", nativeID: "CreateAccountIntro.content.createAccountIntro.bodyText" }, i18n.t('CreateAccountIntro.content.createAccountIntro.bodyText', {
                    appName,
                }))))));
}
export { RegisterMinorAccountIntro };
